export default {
  rooms: 'Camere:',
  area: 'Suprafață:',
  ai_predictions_title: '📊 Evaluări prognozate ale prețului de către AI',
  more: 'Mai multe detalii +',

  // 🏷 Tip tranzacție
  purpose: {
    sale: 'De vânzare',
    rent: 'De închiriat',
    short_term: 'Închiriere pe termen scurt'
  }
}
